import React from 'react';

export const DynamicFacebookIcon = ({ className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      className={className}
    >
      <g filter="url(#filter0_d_6160_6707)">
        <rect
          x="4.5"
          y="0.498047"
          width="54"
          height="54"
          rx="27"
          fill="white"
          fillOpacity="0.3"
          shapeRendering="crispEdges"
        />
        <rect
          x="5"
          y="0.998047"
          width="53"
          height="53"
          rx="26.5"
          stroke="#AB9005" // Default fallback color
          shapeRendering="crispEdges"
        />
        <circle cx="31.5" cy="27.498" r="17" fill="var(--color-primary)" />
        <path
          d="M34.864 24.3265H32.0155V22.4583C32.0155 21.7568 32.4805 21.5932 32.808 21.5932C33.1348 21.5932 34.8182 21.5932 34.8182 21.5932V18.5089L32.0498 18.498C28.9766 18.498 28.2773 20.7984 28.2773 22.2706V24.3265H26.5V27.5048H28.2773C28.2773 31.5835 28.2773 36.498 28.2773 36.498H32.0155C32.0155 36.498 32.0155 31.5351 32.0155 27.5048H34.538L34.864 24.3265Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_6160_6707"
          x="0.5"
          y="0.498047"
          width="62"
          height="62"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_6160_6707"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_6160_6707"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
